var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35023 14.5C9.1214 14.5 8.93164 14.3102 8.93164 14.0814V7.94203C8.93164 7.7132 9.1214 7.52344 9.35023 7.52344C9.57906 7.52344 9.76883 7.7132 9.76883 7.94203V14.0814C9.76883 14.3102 9.57906 14.5 9.35023 14.5Z",
    fill: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35023 6.1278C9.1214 6.1278 8.93164 5.93804 8.93164 5.70921V2.91859C8.93164 2.68976 9.1214 2.5 9.35023 2.5C9.57906 2.5 9.76883 2.68976 9.76883 2.91859V5.70921C9.76883 5.93804 9.57906 6.1278 9.35023 6.1278Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44594 14.4989C5.21711 14.4989 5.02734 14.3091 5.02734 14.0803V11.2897C5.02734 11.0609 5.21711 10.8711 5.44594 10.8711C5.67477 10.8711 5.86453 11.0609 5.86453 11.2897V14.0803C5.86453 14.3091 5.67477 14.4989 5.44594 14.4989Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44594 9.47654C5.21711 9.47654 5.02734 9.28678 5.02734 9.05795V2.91859C5.02734 2.68976 5.21711 2.5 5.44594 2.5C5.67477 2.5 5.86453 2.68976 5.86453 2.91859V9.05795C5.86453 9.28678 5.67477 9.47654 5.44594 9.47654Z",
    fill: "#6C6C6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53187 14.5C1.30304 14.5 1.11328 14.3102 1.11328 14.0814V7.94203C1.11328 7.7132 1.30304 7.52344 1.53187 7.52344C1.7607 7.52344 1.95047 7.7132 1.95047 7.94203V14.0814C1.95047 14.3102 1.7607 14.5 1.53187 14.5Z",
    fill: "#6C6C6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53187 6.1278C1.30304 6.1278 1.11328 5.93804 1.11328 5.70921V2.91859C1.11328 2.68976 1.30304 2.5 1.53187 2.5C1.7607 2.5 1.95047 2.68976 1.95047 2.91859V5.70921C1.95047 5.93804 1.7607 6.1278 1.53187 6.1278Z",
    fill: "#6C6C6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65109 8.36062H0.418593C0.189762 8.36062 0 8.17086 0 7.94203C0 7.7132 0.189762 7.52344 0.418593 7.52344H2.65109C2.87992 7.52344 3.06968 7.7132 3.06968 7.94203C3.06968 8.17086 2.87992 8.36062 2.65109 8.36062Z",
    fill: "#6C6C6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4655 8.36062H8.23305C8.00422 8.36062 7.81445 8.17086 7.81445 7.94203C7.81445 7.7132 8.00422 7.52344 8.23305 7.52344H10.4655C10.6944 7.52344 10.8841 7.7132 10.8841 7.94203C10.8841 8.17086 10.6944 8.36062 10.4655 8.36062Z",
    fill: "#6C6C6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55929 9.47683H4.3268C4.09797 9.47683 3.9082 9.28707 3.9082 9.05824C3.9082 8.82941 4.09797 8.63965 4.3268 8.63965H6.55929C6.78812 8.63965 6.97788 8.82941 6.97788 9.05824C6.97788 9.28707 6.78812 9.47683 6.55929 9.47683Z",
    fill: "#6C6C6C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.2828,
    y1: 1.74846e-8,
    x2: 21.2828,
    y2: 17,
    stroke: "#6C6C6C",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.12b23d59e873ab9915e3b82fbf8a2d18.svg";
export { ForwardRef as ReactComponent };